import type { FontLookup } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { TEXT_OPTION_ID_FALLBACK_CLASS } from './text-option-id-fallback';

interface QuoteFontLabelProps {
  readonly fontId: string;
  /** 이름 찾기 결과 — 불러오는 중·실패·못 찾은 id 면 undefined. */
  readonly font: FontLookup | undefined;
}

/** 견적 사본의 폰트 하나 — 이름(지운 폰트는 '(삭제됨)'), 이름을 모르면 id 를 그대로 보여 준다. */
export const QuoteFontLabel = ({ fontId, font }: QuoteFontLabelProps): ReactElement => {
  if (font === undefined) {
    return <span className={TEXT_OPTION_ID_FALLBACK_CLASS}>{fontId}</span>;
  }

  return (
    <span title={fontId}>
      {font.familyName}
      {font.deleted ? <span className="ml-1 text-xs text-destructive">(삭제됨)</span> : null}
    </span>
  );
};
